/**
 * @desc Wrapper over TabbyJS
 * @see {@link https://github.com/cferdinandi/tabby}
 */
export default class MCTabs {
  /**
   * @param {Object} options - TabbyJS options
   * @param {string} options.tabsSelector
   * @param {string} options.defaultTabSelector
   */
  constructor({ tabsSelector = 'data-mc-tabs-id', defaultTabSelector = '[data-mc-default-tab]' } = {}) {
    this.tabsSelector = tabsSelector;
    this.defaultTabSelector = defaultTabSelector;

    this.init();
  }

  async init() {
    this.isInitialized = true;

    const tabs = document.querySelectorAll(`[${this.tabsSelector}]`);

    if (!tabs.length) {
      this.isInitialized = false;

      return;
    }

    try {
      const { default: Tabby } = await import('tabbyjs/dist/js/tabby.polyfills');

      this.tabbyInstances = [];
      tabs.forEach((el) => {
        this.tabbyInstances.push(
          new Tabby(`[${this.tabsSelector}='${el.dataset.mcTabsId}']`, { default: this.defaultTabSelector }),
        );
      });
    } catch (error) {
      console.error(`An error was occured during initialization tabs with TabbyJS: ${error}`);
    }
  }
}
